import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Popover } from '@abyss/web/ui/Popover';
import { Text } from '@abyss/web/ui/Text';
import find from 'lodash/find';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { phoneOnly } from '../ConstantsStyles';
import {
  distanceInfoIconText,
  distancePopover,
  drawerStyle,
} from '../RadioGroup/DistanceInfoIcon.styled';

export const NetworkAffiliationsInfoIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);

  const data = useLagoon('ui-messaging')();
  const networkAffiliationsFilterContent = find(data, {
    key: ConstantsLagoon.CONTENT_FILTERS
      .NETWORK_AFFILIATIONS_FILTER_INFO_MESSAGE,
  });

  const popOverContent: string =
    networkAffiliationsFilterContent?.message || '';
  const popOverTitle: string = networkAffiliationsFilterContent?.title || '';

  const content = () => (
    <Flex
      alignItems="center"
      css={{ paddingTop: '12px' }}
      data-auto-testid="network-affiliations-info-icon-button"
      data-testid="network-affiliations-info-icon-button"
      onClick={() => setIsOpen(true)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsOpen(true);
        }
      }}
    >
      <IconSymbol
        aria-hidden="true"
        data-testid="network-affiliations-info-icon"
        focusable="false"
        icon="info"
        size={16}
        variant="outlined"
      />
      <div style={{ marginLeft: '4px' }} />
      <Text
        css={distanceInfoIconText}
        data-testid="network-affiliations-info-icon-text"
      >
        {t('CONTENT_FILTERS.ALL_FILTERS_DRAWER.NETWORK_AFFILIATIONS_INFO_LINK')}
      </Text>
    </Flex>
  );

  return (
    <React.Fragment>
      {!mobileScreen ? (
        <Popover
          content={popOverContent}
          css={distancePopover}
          data-testid="network-affiliations-info-icon-popover"
          onOpenChange={() => {
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          title={popOverTitle}
          width={220}
        >
          {content()}
        </Popover>
      ) : (
        <React.Fragment>
          {content()}
          <Drawer
            css={drawerStyle}
            data-auto-testid="network-affiliations-info-icon-popover"
            data-testid="network-affiliations-info-icon-popover"
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            position="bottom"
            title={popOverTitle}
            titleAlign="left"
          >
            <Drawer.Section>{popOverContent}</Drawer.Section>
          </Drawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
